import Styles from "./styles";
import { useState } from "react";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

// img
import IconArrowBottom from "resources/image/icon/icon_arrow_bottom_triangle.svg";

function ModelSelect({ optionList, placeholder, select, setSelect }) {
  const [isOptionOpen, setIsOptionOpen] = useState(false);

  return (
    <Styles.Container>
      <div
        className={"nowSelect" + (isOptionOpen ? " open" : "")}
        onClick={() => {
          setIsOptionOpen(!isOptionOpen);
        }}
      >
        {select !== "" ? select : placeholder}

        <div className="iconWrap">
          <img src={IconArrowBottom} alt="IconArrowBottom" />
        </div>
      </div>

      {isOptionOpen && (
        <Styles.OptionContainer>
          <OverlayScrollbarsComponent
            className="menuContainer"
            options={{ scrollbars: { autoHide: "scroll" } }}
          >
            <ul className="optionListWrap">
              {optionList?.map((item, index) => {
                return (
                  <li
                    className="optionList"
                    key={"optionList" + index}
                    onClick={() => {
                      setSelect(item.title);
                      setIsOptionOpen(false);
                    }}
                  >
                    {item.title}
                  </li>
                );
              })}
            </ul>
          </OverlayScrollbarsComponent>
        </Styles.OptionContainer>
      )}
    </Styles.Container>
  );
}

export default ModelSelect;
